
export const CheckSwitchIcon = () => {
  return <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 4L5 8L3 6" stroke="#252525" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>;
};
